module.exports = __webpack_public_path__ + "img/logo-4.32904d66.svg";